// extracted by mini-css-extract-plugin
export var button = "_j-0";
export var buttonContent = "_j-e";
export var buttonGroup = "_j-c";
export var dontRestrainIconWidth = "_j-a";
export var dropdownButton = "_j-b";
export var iconContainer = "_j-9";
export var lg = "_j-4";
export var md = "_j-3";
export var pending = "_j-f";
export var sm = "_j-2";
export var spinner = "_j-d";
export var squared = "_j-8";
export var wrapText = "_j-g";
export var xl = "_j-5";
export var xs = "_j-1";
export var xxl = "_j-6";
export var xxxl = "_j-7";